import { toast } from "react-toastify";
import axios from "../../../service/axios";


export async function updateLayoutObjectApi({ id, payload }, cancelToken) {
    try {
        const res = await axios.patch(`/layout-objects/${id}`, payload, {
            cancelToken,
        });
        return res;
    } catch (error) {
        console.error("Object Position Update Error:", error);
        throw error;
    }
}

export async function duplicateLayoutObjectApi(id, cancelToken) {
    try {
        const res = await axios.post(`/layout-objects/duplicate/${id}`, {}, {
            cancelToken,
        });
        return res;
    } catch (error) {
        console.error("Duplicate Layout Object Error:", error);
        throw error;
    }
}

export async function deleteLayoutObjectApi(id, cancelToken) {
    try {
        const res = await axios.delete(`/layout-objects/${id}`, {
            cancelToken,
        });
        return res;
    } catch (error) {
        console.error("Delete Layout Object Error:", error);
        throw error;
    }
}